module.exports = __webpack_public_path__ + "img/defaultAvatar.61a07895.svg";